import userPlans from '@/hooks/userPlans';
import { apiCaller } from '@/redux/query';
import { previewBackupSelector } from '@/redux/slice/preview.slice';
import { useSelector } from 'react-redux';

const UseLimitPlan = () => {
  const { isUserFreeOrBasic, isUserBasic } = userPlans();

  const { status: statusBackup, id } = useSelector(previewBackupSelector) ?? {};

  const { data, isLoading } = apiCaller.useGetTotalRuleActiveQuery();

  const isLoadingTotalRuleActive = isLoading;
  const numberRulePopupActive = Number(data?.ruleCount?.popup) || 0;
  const numberRuleTranslation = data?.ruleCount?.translation || 0;

  const isLimitOneRulePopup = numberRulePopupActive >= 1 && isUserFreeOrBasic;
  const shouldShowWhenUpdateRulePopupDisabled = isLimitOneRulePopup && !statusBackup && Boolean(id);
  const shouldShowWhenCreateNewRulePopup = isLimitOneRulePopup && !id;
  const isShowUpgradeNowRulePopup = shouldShowWhenUpdateRulePopupDisabled || shouldShowWhenCreateNewRulePopup; // Đối với Free và Basic thì chỉ được enable 1 rule popup

  const isLimitOneRuleTranslation = numberRuleTranslation >= 1 && isUserBasic;

  return {
    isLoadingTotalRuleActive,
    numberRulePopupActive,
    numberRuleTranslation,
    isLimitOneRulePopup,
    isShowUpgradeNowRulePopup,
    isLimitOneRuleTranslation,
  };
};

export default UseLimitPlan;
